import { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon, Typography } from '@scale/scaleui';
import { SearchScope } from '../plugins/scopeSearchPlugin';
import { useMagicSearch } from '../MagicSearchContext';

type SearchResultsListItemRecentSearchProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  id: string;
  searchText: string;
  searchScopes: SearchScope[];
  isFocused?: boolean;
  disableHover?: boolean;
};

export const SearchResultsListItemRecentSearch: React.FC<
  SearchResultsListItemRecentSearchProps
> = ({ className, children, isFocused, disableHover, id, searchText, searchScopes, ...other }) => {
  const { onUpdateState } = useMagicSearch(s => ({
    onUpdateState: s.onUpdateState,
  }));

  return (
    <button
      className={twMerge(
        'w-full min-h-12 p-3 py-2 flex items-center gap-1',
        !disableHover && 'hover:bg-neutral-100',
        isFocused && 'bg-neutral-100',
        className,
      )}
      {...other}
      onClick={() => onUpdateState({ searchText, searchScopes })}
    >
      <Icon icon={['fas', 'clock']} size="md" className="flex-shrink-0" />
      <Typography.Paragraph2 className={twMerge('text-neutral-900 font-medium')}>
        {searchText}
      </Typography.Paragraph2>
    </button>
  );
};
